import React from 'react'

import * as styles from './FullPageSpinner.module.scss'

import Spinner from '@icons/spinner.svg'

const FullPageSpinner: React.FC = () => {
	return (
		<div className={styles.spinner}>
			<Spinner />
		</div>
	)
}

export default FullPageSpinner
